import { render, staticRenderFns } from "./render-somatory-column-value.vue?vue&type=template&id=d7e0e8ec"
import script from "./render-somatory-column-value.vue?vue&type=script&lang=js"
export * from "./render-somatory-column-value.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7e0e8ec')) {
      api.createRecord('d7e0e8ec', component.options)
    } else {
      api.reload('d7e0e8ec', component.options)
    }
    module.hot.accept("./render-somatory-column-value.vue?vue&type=template&id=d7e0e8ec", function () {
      api.rerender('d7e0e8ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/ui/render/render-somatory-column-value.vue"
export default component.exports